/**
 * The base cost of each level
 */
export const baseLevelCost: number = 1000;
/**
 * The number of levels per increment when increasing the level cost
 */
export const levelCostIncrement: number = 40;
/**
 * How much to increase the level cost per increment
 */
export const levelCostMultiplier: number = 100;

export const unlockThreeStar: number = 21;

export const lastFreePlusFiveBooster: number = 3;
export const SpinWheelUnlockLevel: number = 15;
export const toolboxUnlockLevel: number = 25;

export const STREAK_PROGRESS_STEPS = 5;
export const JOKER_STREAK_REWARD_CHANCE = 0.25;

export const DAILY_LOGIN_UNLOCK_LEVEL: number = 4;
export const SUNDAY_OFFERS_LEVEL_UNLOCK = 17;

export namespace LevelHelperSettings {
    /**
     * Level to begin enabling the dynamic difficulty
     */
    export const dynamicStartLevel: number = 100;
    /**
     * The max # of attempts at a level before the diffculty is no longer reset on completion
     */
    export const maxAttemptsToResetDifficulty: number = 2;
    /**
     * The min # of attempts at a level before the difficulty is reduced
     */
    export const minAttemptsToReduceDifficulty: number = 2;
    /**
     * The chance to add a random card to the stack
     */
    export const stackBreakChance: number = 0.6;
    /**
     * How long to store the difficulty reduction
     */
    export const idleTimeToResetDifficulty: number =
        4 * 7 * 24 * 60 * 60 * 1000;
    /**
     * The multiplier applied to the difficulty reduction level to get the match chance
     */
    export const difficultyReductionToMatchChance: number = 0.05;
    /**
     * The cap for matchChance
     */
    export const maxMatchChance: number = 1.0;
    /**
     * The initial match chance
     */
    export const initialMatchChance: number = 0.25;
}
